import { API_BASE } from "../utils/baseapiurl";

class NetworkAPI {
	async getNetwork(userId = null) {
		try {
			const url = new URL(`${API_BASE}/network`, window.location.origin);
			if (userId) url.searchParams.set("user_id", userId);

			const response = await fetch(url.toString(), {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					"X-WP-Nonce": window.wpApiSettings?.nonce || "",
				},
				credentials: "include",
			});

			if (!response.ok) {
				throw new Error("Failed to fetch agent network");
			}

			return await response.json();
		} catch (error) {
			console.error("Error fetching network:", error);
			throw error;
		}
	}

	async updateHierarchy(payload) {
		try {
			const response = await fetch(`${API_BASE}/network/update-hierarchy`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"X-WP-Nonce": window.wpApiSettings?.nonce || "",
				},
				body: JSON.stringify(payload),
				credentials: "include",
			});

			const data = await response.json();
			if (!response.ok) {
				throw new Error(data.message || "Failed to update hierarchy");
			}

			return data;
		} catch (error) {
			console.error("Error updating hierarchy:", error);
			throw error;
		}
	}
}

export default new NetworkAPI();
